import React from 'react'
import { Container, State, TextBody } from '@pmi/pmi-iqos-ds-react'
import { LazyImage } from '@pmi/pmi-iqos-shared-react'

const SelectableOption = ({ option, isSelected, onClickHandler, image }) => {
  const hasImage = image && image.length > 0
  return (
    <Container
      fullWidth
      display={Container.displays.flex}
      justifyContent={Container.justifyContentValues.between}
      alignItems={Container.alignItemsValues.center}>
      <Container
        pt="6"
        px={['4', '6']}
        pb={hasImage ? '8' : '6'}
        bg={isSelected ? null : Container.backgrounds.hardWhite}
        display={Container.displays.flex}
        flexDirection={
          hasImage
            ? Container.flexDirections.column
            : Container.flexDirections.row
        }
        justifyContent={
          hasImage
            ? Container.justifyContentValues.start
            : Container.justifyContentValues.between
        }
        fullWidth
        fullHeight
        onClickHandler={onClickHandler}
        borderColor={
          isSelected
            ? Container.borderColors.primary
            : Container.borderColors.default
        }>
        <Container
          position={Container.positions.relative}
          fullWidth
          display={[
            hasImage ? Container.displays.flex : null,
            hasImage ? Container.displays.block : Container.displays.flex
          ]}
          justifyContent={
            hasImage ? null : Container.justifyContentValues.between
          }>
          {hasImage && (
            <Container
              height={['20', '56']}
              width={['4/12', 'full']}
              display={Container.displays.flex}
              justifyContent={Container.justifyContentValues.center}>
              <LazyImage src={image} />
            </Container>
          )}
          <Container
            display={hasImage ? Container.displays.flex : null}
            width={[hasImage ? '8/12' : 'full', 'full']}
            pt={['0', hasImage ? '4' : '']}
            justifyContent={
              hasImage
                ? [
                    Container.justifyContentValues.start,
                    Container.justifyContentValues.center
                  ]
                : Container.justifyContentValues.start
            }>
            <Container pr={hasImage ? ['8', '0'] : '8'}>
              <TextBody value={option} breakWords />
            </Container>
          </Container>
          {isSelected ? (
            <Container
              zIndex="1"
              position={Container.positions.absolute}
              t={'0'}
              r={'0'}>
              <State state={State.states.valid} />{' '}
            </Container>
          ) : null}
        </Container>
      </Container>
    </Container>
  )
}

export default SelectableOption
